// Lucide icons (ISC licence), imported one by one so only these are bundled.
import {
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Check,
  ChevronLeft,
  ChevronRight,
  CircleCheck,
  CircleQuestionMark,
  Combine,
  Copy,
  Cpu,
  Download,
  Eraser,
  ExternalLink,
  EyeOff,
  File,
  FileImage,
  FileMinus,
  FileOutput,
  FilePlus,
  FileText,
  FileType,
  Files,
  GripVertical,
  HardDrive,
  Image,
  Info,
  Languages,
  Layers,
  LayoutGrid,
  ListOrdered,
  Lock,
  LockOpen,
  Minimize2,
  Moon,
  PenLine,
  Plus,
  Presentation,
  RefreshCw,
  RotateCcw,
  RotateCw,
  ScanSearch,
  ScanText,
  Scissors,
  Search,
  Sheet,
  ShieldCheck,
  Signature,
  SquareDashed,
  Stamp,
  Sun,
  Tags,
  TextSearch,
  Trash,
  TriangleAlert,
  Type,
  Upload,
  Wifi,
  WifiOff,
  Wrench,
  X,
  Zap,
  createElement,
  type IconNode,
} from 'lucide';

const ICONS: Record<string, IconNode> = {
  archive: Archive,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  check: Check,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'circle-check': CircleCheck,
  help: CircleQuestionMark,
  combine: Combine,
  copy: Copy,
  cpu: Cpu,
  download: Download,
  eraser: Eraser,
  'external-link': ExternalLink,
  'eye-off': EyeOff,
  file: File,
  'file-image': FileImage,
  'file-minus': FileMinus,
  'file-output': FileOutput,
  'file-plus': FilePlus,
  'file-text': FileText,
  'file-type': FileType,
  files: Files,
  grip: GripVertical,
  'hard-drive': HardDrive,
  image: Image,
  info: Info,
  languages: Languages,
  layers: Layers,
  'layout-grid': LayoutGrid,
  'list-ordered': ListOrdered,
  lock: Lock,
  'lock-open': LockOpen,
  'minimize-2': Minimize2,
  moon: Moon,
  pen: PenLine,
  plus: Plus,
  presentation: Presentation,
  refresh: RefreshCw,
  'rotate-ccw': RotateCcw,
  'rotate-cw': RotateCw,
  'scan-search': ScanSearch,
  'scan-text': ScanText,
  scissors: Scissors,
  search: Search,
  sheet: Sheet,
  'shield-check': ShieldCheck,
  signature: Signature,
  'square-dashed': SquareDashed,
  stamp: Stamp,
  sun: Sun,
  tags: Tags,
  'text-search': TextSearch,
  trash: Trash,
  warning: TriangleAlert,
  type: Type,
  upload: Upload,
  wifi: Wifi,
  'wifi-off': WifiOff,
  wrench: Wrench,
  x: X,
  zap: Zap,
};

export function icon(name: string, label?: string): SVGElement {
  const node = ICONS[name] ?? File;
  const svg = createElement(node, { 'stroke-width': 2, 'aria-hidden': label ? undefined : 'true' } as never);
  if (label) {
    svg.setAttribute('role', 'img');
    svg.setAttribute('aria-label', label);
  }
  return svg;
}
